/** Служебный UI только для платформенного супер-админа (см. PLAN_TEAM_PRODUCT_MODEL.md). */

export const SUPER_ADMIN_UI_EMAIL = '1234@mail.ru';

export const SUPER_ADMIN_HIDDEN_BADGE = 'Скрыто от пользователей';

export const SUPER_ADMIN_ONLY_SETTINGS_HREFS = [
  '/settings/roles',
  '/settings/access-levels',
  '/settings/compliance',
  '/settings/reference',
] as const;

export const SUPER_ADMIN_ONLY_CHECKLISTS_HREFS = [
  '/checklists/diagnostics',
  '/checklists/missed',
] as const;

export const SUPER_ADMIN_ONLY_MODULE_PREFIXES = ['/cash', '/consumables'] as const;

export function isSuperAdminUi(email?: string | null): boolean {
  return (email || '').trim().toLowerCase() === SUPER_ADMIN_UI_EMAIL;
}

/** Снабжение в WebAdmin — только платформенный super. */
export function isConsumablesUiVisible(email?: string | null): boolean {
  return isSuperAdminUi(email);
}

export function isSuperAdminOnlyModulePath(pathname?: string | null): boolean {
  if (!pathname) return false;
  return SUPER_ADMIN_ONLY_MODULE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

/** Служебный контур ведомостей (payroll ledger) — только платформенный super. */
export function showLegacyPayrollUi(email?: string | null): boolean {
  return isSuperAdminUi(email);
}
  